import { FeatureFlagKey } from '@databases/feature-flags/flags';
import {
  featureFlagClientManager,
  getFlagValue as internalGetFlagValue,
} from '@databases/feature-flags/manager';
import { addOverrides } from '@databases/feature-flags/overrides/persisted';
import { snapshot } from 'valtio';

import { logs } from './logger/ActivityLogger';
import { LogEntry } from './logger/types';

const setFlagOverride = (flag: string, value: boolean) => {
  addOverrides({ [flag]: value });
  featureFlagClientManager.applyOverrides();
};

const getFlagValue = (flag: FeatureFlagKey, defaultValue = false) => {
  return internalGetFlagValue(flag, defaultValue);
};

export type DatabaseState = {
  isDatabaseConnected: boolean;
  getLogs: () => readonly LogEntry[];
  setFlagOverride: (flag: string, value: boolean) => void;
  getFlagValue: (flag: FeatureFlagKey, defaultValue?: boolean) => boolean;
};

export const databaseState: DatabaseState = {
  isDatabaseConnected: false,
  getLogs: () => snapshot(logs),
  setFlagOverride,
  getFlagValue,
};
